export const  GET_SELF_CUSTOM_RESULT = 'printPage/get_self_custom_result';//获取自家消费结果

export const  SET_SELF_CUSTOM_RESULT = 'printPage/set_self_custom_result';//设置自家消费结果

export const  SET_LOADING = 'printPage/set_loading';//设置自家消费结果

